var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgE1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.993 59.9927C119.993 26.8556 93.1298 -0.00726725 59.9927 -0.00726581C26.8556 -0.00726436 -0.00732829 26.8557 -0.00732684 59.9927C-0.00732539 93.1298 26.8556 119.993 59.9927 119.993C93.1298 119.993 119.993 93.1298 119.993 59.9927Z",
    fill: "#FA364C"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5769 47.3396C47.5769 51.8212 44.388 55.4575 40.4605 55.4575C36.5329 55.4575 33.344 51.8212 33.344 47.3396C33.344 42.8581 36.5329 39.2217 40.4605 39.2217C44.388 39.2217 47.5769 42.8581 47.5769 47.3396Z",
    fill: "#939598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0428 47.3396C86.0428 51.8212 82.8538 55.4575 78.9263 55.4575C74.9987 55.4575 71.8098 51.8212 71.8098 47.3396C71.8098 42.8581 74.9987 39.2217 78.9263 39.2217C82.8538 39.2217 86.0428 42.8581 86.0428 47.3396Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1407 36.3027C42.0939 34.3069 38.4646 33.3765 34.8282 33.6606C33.5711 33.753 32.3069 33.0214 32.0086 31.8141C31.7032 30.6138 32.8112 29.3069 34.4802 29.1791C39.1038 28.824 43.7203 30.003 47.5981 32.5456C49.0044 33.4618 49.3453 35.145 48.5001 36.047C47.6549 36.9561 46.199 36.9916 45.1407 36.3027Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2388 36.3027C77.2857 34.3069 80.9149 33.3765 84.5513 33.6606C85.8084 33.753 87.0726 33.0214 87.3709 31.8141C87.6763 30.6138 86.5683 29.3069 84.8993 29.1791C80.2757 28.824 75.6592 30.003 71.7814 32.5456C70.3752 33.4618 70.0342 35.145 70.8794 36.047C71.7246 36.9561 73.1806 36.9916 74.2388 36.3027Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1011 89.8183C82.1863 90.6067 81.3127 91.1535 80.6593 90.699C76.5258 87.922 68.8198 85.1805 59.7005 85.3226C50.5741 85.1734 42.8752 87.922 38.7417 90.699C38.692 90.7416 38.6352 90.7629 38.5855 90.7842C37.9534 91.0683 37.2147 90.5498 37.3 89.8183C37.5414 87.6024 37.9818 85.6209 38.5855 83.8666C43.621 69.2288 59.7076 70.0172 59.7076 70.0172C59.7076 70.0172 79.8568 69.037 82.1082 89.8254L82.1011 89.8183Z",
    fill: "#939598"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE1);
export default __webpack_public_path__ + "static/media/E1.7788e7d96c3f82302769dd9cbda4b564.svg";
export { ForwardRef as ReactComponent };